/**
 * The label a page gives a field often ends with the punctuation of a form
 * ("Mots-clés :", "Nom *"). The Console shows the words, never the decoration,
 * and falls back to the technical key when the page gave the field no label.
 */
export function displayFieldLabel(label: string | null, fieldKey: string): string {
  const cleaned = (label ?? '').replace(/[\s:*]+$/u, '').trim();
  return cleaned.length > 0 ? cleaned : fieldKey;
}
